import * as api from '../../api/appraisalDemo/summary';
import { makeApiActionCreatorV3 } from '../utils';

export const PROPERTY_FETCH_START = 'SUMMARY/PROPERTY_FETCH_START';
export const PROPERTY_FETCH_SUCCESS = 'SUMMARY/PROPERTY_FETCH_SUCCESS';
export const PROPERTY_FETCH_ERROR = 'SUMMARY/PROPERTY_FETCH_ERROR';

export const fetchProperty = makeApiActionCreatorV3(
  api.fetchProperty,
  PROPERTY_FETCH_START,
  PROPERTY_FETCH_SUCCESS,
  PROPERTY_FETCH_ERROR,
);
